<mat-toolbar class="shell__toolbar">
  <div class="shell__brand">
    <a class="shell__badge" routerLink="/">
      {{ title }}
    </a>
    @if (currentUser()) {
      <details class="shell__group-dropdown" #groupDropdown>
        <summary class="shell__group-trigger">
          <span class="shell__group-trigger-text">{{ selectedGroupName() }}</span>
        </summary>

        <div class="shell__group-menu">
          @if (groupsLoading()) {
            <div class="shell__group-empty">{{ i18n.t('mainMenu.loadingGroups') }}</div>
          } @else if (groups().length === 0) {
            <div class="shell__group-empty">{{ i18n.t('mainMenu.noGroupsAvailable') }}</div>
          } @else {
            @for (group of groups(); track group.id) {
              <button
                type="button"
                class="shell__group-option"
                [class.shell__group-option--active]="group.id === selectedGroupId()"
                (click)="selectGroup(group, groupDropdown)"
              >
                <span>{{ group.name }}</span>
                @if (group.id === selectedGroupId()) {
                  <span class="shell__group-option-mark">{{ i18n.t('common.labels.selected') }}</span>
                }
              </button>
            }
          }
        </div>
      </details>
    }
  </div>

  <span class="shell__spacer"></span>

  <div class="shell__actions">
    <div class="shell__preference-toggle" [attr.aria-label]="i18n.t('mainMenu.languageSelector')" role="group">
      @for (language of languages; track language) {
        <button
          type="button"
          class="shell__preference-button"
          [class.shell__preference-button--active]="i18n.language() === language"
          [attr.aria-pressed]="i18n.language() === language"
          (click)="setLanguage(language)"
        >
          {{ language.toUpperCase() }}
        </button>
      }
    </div>
    <div class="shell__preference-toggle" [attr.aria-label]="i18n.t('mainMenu.themeSelector')" role="group">
      @for (theme of themes; track theme) {
        <button
          type="button"
          class="shell__preference-button shell__preference-button--wide"
          [class.shell__preference-button--active]="themeService.theme() === theme"
          [attr.aria-pressed]="themeService.theme() === theme"
          (click)="setTheme(theme)"
        >
          {{ i18n.t('common.themes.' + theme) }}
        </button>
      }
    </div>
    @if (currentUser(); as user) {
      @if (hasAdminAccess()) {
        <button mat-button type="button" routerLink="/admin">{{ i18n.t('common.actions.admin') }}</button>
      }
      <details class="shell__user-dropdown" #userDropdown>
        <summary class="shell__user-trigger">
          <span class="shell__user-avatar" aria-hidden="true">
            @if (currentUserPictureUrl() && !avatarImageFailed()) {
              <img
                class="shell__user-avatar-image"
                [src]="currentUserPictureUrl()!"
                alt=""
                referrerpolicy="no-referrer"
                (error)="onAvatarImageError()"
              >
            } @else {
              <span class="shell__user-avatar-fallback">{{ currentUserInitials() }}</span>
            }
          </span>
        </summary>

        <div class="shell__user-menu">
          <div class="shell__user-info">
            <span class="shell__user-name">{{ currentUserLabel() }}</span>
          </div>
          <div class="shell__user-actions">
            <a class="shell__user-action" routerLink="/profile" (click)="closeUserDropdown(userDropdown)">
              {{ i18n.t('profile.title') }}
            </a>
            <button class="shell__user-action" type="button" (click)="logout(); closeUserDropdown(userDropdown)">
              {{ i18n.t('common.actions.logout') }}
            </button>
          </div>
        </div>
      </details>
    } @else {
      <div class="shell__auth-buttons" [attr.aria-label]="i18n.t('mainMenu.signInProviders')">
        <button
          type="button"
          class="shell__auth-button shell__auth-button--google"
          [attr.aria-label]="i18n.t('mainMenu.signInWithGoogle')"
          [title]="i18n.t('mainMenu.signInWithGoogle')"
          (click)="loginWithGoogle()"
        >
          <div class="PDfDtf">
            <svg class="th8JXc" xmlns="https://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 40 48"
                 aria-hidden="true" jsname="jjf7Ff" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
                 xsi:schemaLocation="https://www.w3.org/2000/svg ">
              <path fill="#4285F4"
                    d="M39.2 24.45c0-1.55-.16-3.04-.43-4.45H20v8h10.73c-.45 2.53-1.86 4.68-4 6.11v5.05h6.5c3.78-3.48 5.97-8.62 5.97-14.71z"></path>
              <path fill="#34A853"
                    d="M20 44c5.4 0 9.92-1.79 13.24-4.84l-6.5-5.05C24.95 35.3 22.67 36 20 36c-5.19 0-9.59-3.51-11.15-8.23h-6.7v5.2C5.43 39.51 12.18 44 20 44z"></path>
              <path fill="#FABB05"
                    d="M8.85 27.77c-.4-1.19-.62-2.46-.62-3.77s.22-2.58.62-3.77v-5.2h-6.7C.78 17.73 0 20.77 0 24s.78 6.27 2.14 8.97l6.71-5.2z"></path>
              <path fill="#E94235"
                    d="M20 12c2.93 0 5.55 1.01 7.62 2.98l5.76-5.76C29.92 5.98 25.39 4 20 4 12.18 4 5.43 8.49 2.14 15.03l6.7 5.2C10.41 15.51 14.81 12 20 12z"></path>
            </svg>
          </div>
        </button>

        <button
          type="button"
          class="shell__auth-button shell__auth-button--microsoft"
          [attr.aria-label]="i18n.t('mainMenu.signInWithMicrosoft')"
          [title]="i18n.t('mainMenu.signInWithMicrosoft')"
          (click)="loginWithMicrosoft()"
        >
          <img class="shell__auth-icon" src="/ms.png" alt="" aria-hidden="true">
        </button>
      </div>
    }
  </div>
</mat-toolbar>
